import { colmarLogoBase64 } from 'assets/colmarLogoBase64';

import * as S from './ListItem.styles';
import * as Sk from './ListItemSkeleton.styles';

type ListItemSkeletonProps = {
  layout?: string;
};

const ListItemSkeleton = ({ layout }: ListItemSkeletonProps): React.ReactElement => (
  <S.Wrapper layout={layout}>
    <S.ImageWrapper layout={layout}>
      <Sk.LogoPlaceholder src={colmarLogoBase64} alt="" aria-hidden="true" />
    </S.ImageWrapper>

    <S.Titles>
      <Sk.TitleLine width="155px" />
      <Sk.TitleLine width="50px" />
    </S.Titles>

    <S.CTA>
      <Sk.CTABlock />
      <Sk.CTABlock />
    </S.CTA>
  </S.Wrapper>
);

export { ListItemSkeleton };
